import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="member-profile"
export default class extends Controller {
  static targets = [
    'form',
  ]

  declare readonly formTarget: HTMLFormElement

  submit () {
    // submit form without a full reload
    this.formTarget.requestSubmit()
  }
}
